/* OPAAL DESSAU v1.1 – tier prices follow the selected variant */
(() => {
  const fmt = (c) => {
    const f = (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    const v = (c / 100).toFixed(2).split('.');
    const n = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    return f.replace(/\{\{\s*\w+\s*\}\}/, n);
  };
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option]')) return;
    const section = e.target.closest('[data-product-section]');
    if (!section) return;
    setTimeout(() => {
      const json = section.querySelector('[data-product-json]');
      const id = section.querySelector('[data-variant-id]');
      if (!json || !id) return;
      const v = JSON.parse(json.textContent).variants.find(x => String(x.id) === String(id.value));
      if (!v) return;
      section.querySelectorAll('[data-tiers]').forEach(t => {
        const base = t.querySelector('.tiers__cell--base strong');
        if (base) base.textContent = fmt(v.price);
        t.querySelectorAll('[data-tier-pct]').forEach(c => {
          const el = c.querySelector('[data-tier-price]');
          if (el) el.textContent = fmt(Math.round(v.price * (100 - parseFloat(c.dataset.tierPct)) / 100));
        });
      });
    }, 30);
  });
})();

/* v1.2 – gallery counter instead of dots when a product has many images */
(() => {
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('[data-gallery-track]');
    const dots = g.querySelector('[data-gallery-dots]');
    if (!track || !dots || dots.children.length <= 8) return;
    dots.style.display = 'none';
    const box = document.createElement('div');
    box.className = 'gallery__counter';
    box.innerHTML = '<span data-gallery-current>1</span> / ' + dots.children.length;
    dots.after(box);
    const cur = box.firstChild;
    track.addEventListener('scroll', () => {
      cur.textContent = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1;
    }, { passive: true });
  });
})();

/* v1.3 – expected delivery window on product pages (6–10 working days per supplier; policies keep a wider safety window) */
(() => {
  const form = document.querySelector('[data-product-form]');
  if (!form || document.querySelector('.delivery-eta')) return;
  const addBiz = (from, n) => { const d = new Date(from); while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
  const now = new Date();
  const min = addBiz(now, 6), max = addBiz(now, 10);
  const f = (d, o) => d.toLocaleDateString('nl-NL', o);
  const range = min.getMonth() === max.getMonth()
    ? min.getDate() + ' – ' + f(max, { day: 'numeric', month: 'long' })
    : f(min, { day: 'numeric', month: 'short' }) + ' – ' + f(max, { day: 'numeric', month: 'short' });
  const y = now.getFullYear();
  let gift = '';
  if (now.getMonth() >= 9) {
    if (max <= new Date(y, 11, 4)) gift = 'Op tijd voor Sinterklaas';
    else if (max <= new Date(y, 11, 23)) gift = 'Op tijd voor kerst';
  }
  const p = document.createElement('p');
  p.className = 'delivery-eta';
  p.style.flexWrap = 'wrap';
  p.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>'
    + '<span style="flex:1;min-width:0">Bestel vandaag, verwacht in huis <strong>' + range + '</strong> · met track &amp; trace</span>'
    + (gift ? '<span class="delivery-eta__gift">' + gift + '</span>' : '');
  form.after(p);
})();
